import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";

const Wrap = styled(Link)`
  display: inline-flex;
  align-items: center;
  padding: 4px;
  background: transparent;
  border: 0;
  cursor: pointer;
  color: var(--nd-text-secondary);
  line-height: 0;
  text-decoration: none;

  &:hover,
  &:focus {
    color: var(--nd-text-display);
    outline: none;
    text-decoration: none;
  }

  &:hover svg path,
  &:focus svg path {
    stroke: var(--nd-text-display);
  }
`;

const HashSvg = () => (
  <svg width="18" height="14" viewBox="0 0 18 14" aria-hidden="true">
    <path
      d="M6 1 L4 13 M12 1 L10 13 M1 5 L15 5 M1 10 L15 10"
      fill="none"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="square"
    />
  </svg>
);

const SlackButton = () => (
  <Wrap
    to="/slack"
    title="Join the Dioscuro Slack — free"
    aria-label="Join the Dioscuro Slack"
  >
    <HashSvg />
  </Wrap>
);

export default SlackButton;
